import { render, staticRenderFns } from "./FormProspecto.vue?vue&type=template&id=78347cf0&"
import script from "./FormProspecto.vue?vue&type=script&lang=js&"
export * from "./FormProspecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports